/**
 * 求人プールからの削除 (BTN-M-014) と、求人プールに無い求人の枠 (画面レイアウト_SCR-M-001.md §4.4・§6.2、Issue #883)
 * の判定。状態を持たない関数だけを置く。
 */

// 枠の文言 (§4.4「求人プールに無い求人の枠」)
export const MISSING_FROM_POOL_TITLE = 'この求人は求人プールにありません。';
export const MISSING_FROM_POOL_NOTE = '削除されたか、求人票が置き換えられたため、推薦 PDF には載りません。';

/**
 * その求人に「削除」(BTN-M-014) を出すか。求人ごとに判定し、① テナントのマネージャー (`is_admin`)
 * ② その求人を取り込んだ本人 (`created_by`) ③ 開いている案件の求人で、その案件の担当者 (案件の `owner_id`)
 * のどれかのときだけ出す (§6.2「BTN-M-014 を出す条件」、Issue #782。マネージャーの定義は CRUD 図 §4.1)。
 * ほかの案件の求人で、その案件の担当者であるだけのときは出さない (画面はほかの案件の owner_id を知らない。
 * サーバは消せる人に画面が出さないだけで、出して 403 になる向きの食い違いは起きない)。
 * 利用者・案件がまだ取れていない間は ① ② だけで判定する (サーバも同じ条件で検査し、外れれば 403)。
 *
 * @param {{id?: string, is_admin?: boolean}|null|undefined} currentUser `/auth/me` の利用者
 * @param {{owner_id?: string}|null|undefined} opportunity `/opportunities/{id}` の案件
 * @param {string} opportunityId 開いている案件の ID
 * @param {{target_candidate_id?: string, created_by?: string|null}} item 一覧の求人
 * @returns {boolean}
 */
export function canDeleteJobPoolItem(currentUser, opportunity, opportunityId, item) {
    if (!currentUser) return false;
    if (currentUser.is_admin === true) return true;
    if (!currentUser.id) return false;
    if (item.created_by === currentUser.id) return true;
    return item.target_candidate_id === opportunityId && opportunity?.owner_id === currentUser.id;
}

/**
 * 推薦カードを「求人プールに無い求人の枠」として出すか。一覧 (DP-M-009) の取得に成功しているのに、
 * その求人が一覧に無いときだけ真 (§4.4)。一覧の取得に失敗している間は、どの求人が消えたかを
 * 判断できないため偽にする (カードは「求人の情報を取得できませんでした。…」を出す)。
 *
 * @param {{jobPoolItem?: object|null}} item 画面の並びの要素
 * @param {boolean} jobPoolLoaded 一覧の取得に成功しているか
 * @returns {boolean}
 */
export function isMissingFromJobPool(item, jobPoolLoaded) {
    return jobPoolLoaded && !item.jobPoolItem;
}

/**
 * 画面に出す順位。枠を数えずに、ほかのカードだけで 1 から振る (§4.4「順位の番号」。推薦 PDF と同じ番号になる)。
 * 枠の位置は null。並びの順 (item.rank) は変えない (並べ替えの保存は ID の並びで送るため)。
 *
 * @param {object[]} items 画面の並び
 * @param {boolean} jobPoolLoaded
 * @returns {(number|null)[]} items と同じ長さ
 */
export function displayRanks(items, jobPoolLoaded) {
    let rank = 0;
    return items.map((item) => (isMissingFromJobPool(item, jobPoolLoaded) ? null : ++rank));
}
